import React from 'react'
import styled from 'styled-components'
import { Currency } from '../../model'
import { useBalance } from '../../hooks'
import { CurrencySymbolImage } from './CurrencySymbolImage'

interface CurrencySelectItemProps {
  currency: Currency
  grayedOut?: boolean
  onClick: () => void
}

export function CurrencySelectItem({ currency, grayedOut, onClick }: CurrencySelectItemProps) {
  const balance = useBalance(currency)
  return (
    <Button grayedOut={grayedOut} onClick={onClick}>
      <div>
        <CurrencySymbolImage symbol={currency.symbol} /> {currency.symbol}
      </div>
      <div>{balance ? balance.formatWithSymbol() : '-'}</div>
    </Button>
  )
}

const Button = styled.button<{ grayedOut?: boolean }>`
  padding: 12px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  opacity: ${({ grayedOut }) => (grayedOut ? '0.6' : '1')};
`
